export default {
  confirmed: 'Confirmed',
  backToDashboard: 'Go back to dashboard',
  viewInvoices: 'View my invoices',
  submitted: 'Submitted',
  submitAnotherRequest: 'Submit another request',
}